import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Result, ValueObject } from '@digibricks/core';
export var GradedPercentage = /*#__PURE__*/function (_ValueObject) {
  _inherits(GradedPercentage, _ValueObject);

  var _super = _createSuper(GradedPercentage);

  function GradedPercentage() {
    _classCallCheck(this, GradedPercentage);

    return _super.apply(this, arguments);
  }

  _createClass(GradedPercentage, [{
    key: "value",
    get: function get() {
      return this.props;
    }
  }], [{
    key: "create",
    value: function create(value) {
      return Result.ok(new GradedPercentage(value));
    }
  }, {
    key: "createWithValidate",
    value: function createWithValidate(value) {
      var resultOrError = this.validate(value);

      if (resultOrError.isFailure) {
        return Result.fail(resultOrError.error);
      }

      return Result.ok(new GradedPercentage(value));
    }
  }, {
    key: "validate",
    value: function validate(props) {
      if (props < 0 || props > 100) {
        return Result.fail('Percentage should in range 0 to 100');
      }

      return Result.ok();
    }
  }, {
    key: "isNegative",
    value: function isNegative(value) {
      return value < 0;
    }
  }]);

  return GradedPercentage;
}(ValueObject);

_defineProperty(GradedPercentage, "default", -1000);